<template>
  <v-form v-show="!loading" @submit.prevent="handleSubmit">
    <v-card>      
      <v-card-text>
        <v-tabs grow v-model="active_tab" slider-color="primary">
          <v-tab tabindex="0" ripple :key="0">Ogólne</v-tab>
          <v-tab tabindex="1" ripple :key="1">Administrator danych osobowych</v-tab>
          <v-tab tabindex="2" ripple :key="2">Inspektor danych osobowych</v-tab>
          <v-tab tabindex="3" ripple :key="3">SMS</v-tab>
          <v-tab tabindex="4" ripple :key="4" v-if="id>0">Komórki organizacyjne</v-tab>
          <v-tab tabindex="5" ripple :key="5" v-if="id>0">Szablony generowania</v-tab>
          <v-tab tabindex="6" ripple :key="6" v-if="id>0 && $can('do','POKO_SystemAdmin')">Dodatkowe placówki</v-tab>
          <v-tab tabindex="7" ripple :key="7" v-if="id>0 && $can('do','POKO_SystemAdmin')">Ustawienia kalendarza</v-tab>
          <v-tab tabindex="8" ripple :key="8" v-if="id>0 && isPayuEnabled" >Ustawienia PayU</v-tab>
          <v-tab tabindex="9" ripple :key="9" v-if="id> 0">Grupy pracowników</v-tab>
          <v-tab tabindex="10" ripple :key="10" v-if="id>0 && $can('do','POKO_SystemAdmin')">Portal pacjenta</v-tab>
          <v-tab tabindex="11" ripple :key="11" v-if="id>0 && isP1Enabled">Integracja P1</v-tab>
          <v-tab-item :key="0" tabindex="0">
            <v-container grid-list-xl v-if="active_tab == 0">
              <v-row row wrap>
                <v-col cols="12">
                  <v-text-field v-model="CompanyName" label="Nazwa firmy"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-row>
                    <v-col cols="6">
                      <v-text-field v-model="AddressLine1" label="Ulica"></v-text-field>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field v-model="numer_budynku" label="Nr. budynku"></v-text-field>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field v-model="numer_lokalu" label="Nr. lokalu"></v-text-field>
                    </v-col>
                  </v-row>

                </v-col>

                <v-col cols="12">
                  <v-text-field v-model="AddressLine2" label="Dodatkowe informacje adresowe"></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="Postcode" :rules="[rules.postcode]" label="Kod pocztowy"></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="City" label="Miasto"></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                      v-model="regon"
                      label="Regon"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="NIP"
                    v-validate="{regex:/^[0-9\+]{10}$/}"
                    name="NIP"
                    id="NIP"
                    :error-messages="errors.collect('NIP')"
                    data-vv-as="NIP"
                    label="NIP"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                      label="Numer kontaktowy"
                      v-validate="{regex:/^[0-9\+]{8,13}$/}"
                      name="ContactNumber"
                      id="ContactNumber"
                      :error-messages="errors.collect('ContactNumber')"
                      data-vv-as="Numer kontaktowy"
                      v-model="ContactNumber"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field label="Email kontaktowy" v-validate="'email'" data-vv-as="Email" name="emailAddress" id="emailAddress" :error-messages="errors.collect('emailAddress')"  v-model="ContactEmail"></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field label="Strona WWW" v-model="www_url"></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field label="Numer księgi rejestrowej" v-model="numer_ksiegi_rejestrowej"></v-text-field>
                </v-col>
                <v-col cols="3">
                  <TimePicker v-model="godzina_otwarcia_start" text="Godzina otwarcia start" :allowallhours="true"></TimePicker>
                </v-col>
                <v-col cols="3">
                  <TimePicker v-model="godzina_otwarcia_koniec" text="Godzina otwarcia koniec"></TimePicker>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-select :items="typy_dzialanosci"
                            label="Typ działalności" placeholder="Wybierz typ działalności..."
                            v-model="typ_dzialanosci"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-file-input @change="onFileChange" label="Wybierz plik logo"  show-size :error="image_error" :error-messages="image_errors" accept="image/*" clearable></v-file-input>
                </v-col>
                <v-col cols="6">
                  <v-img v-if="logo_url" :src="logo_url" max-width="200" max-height="200"></v-img>
                </v-col>
              </v-row>
              <v-card>
                <v-card-title>Globalne ustawienia</v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="6">
                        <v-checkbox v-model="allowRegularVisitCreation" label="Pozwól na tworzenie wizyt cyklicznych"></v-checkbox>
                      </v-col>
                      <v-col cols="6">
                        <v-checkbox v-model="leaveCancelledVisitInCalendar" label="Pozostaw wizyty odwołane na kalendarzu"></v-checkbox>
                      </v-col>
                      <v-col cols="6">
                        <v-checkbox v-model="smsConfirmationWilLBeSent" label="SMS z potwierdzeniem wizyty będzie wysyłany zawsze"></v-checkbox>
                      </v-col>
                      <v-col cols="6">
                        <v-checkbox v-model="showPaymentIconInCalendar" label="Pokazuj ikonę płatności na kalendarzu"></v-checkbox>
                      </v-col>
                      <v-col cols="6">
                        <v-checkbox v-model="showNotesIconInCalendar" label="Pokazuj ikonę uwag na kalendarzu"></v-checkbox>
                      </v-col>
                      <v-col cols="6">
                        <v-checkbox v-model="showAdditionalTherapistsForVisitCreation" label="Pozwalaj na wybór dodatkowych terapeutów na wizytach"></v-checkbox>
                      </v-col>
                      <v-col cols="6">
                        <v-checkbox v-model="sendAutomaticInvintations" label="Wysyłaj automatyczne zaproszenia"></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-container>
          </v-tab-item>
          <v-tab-item :key="1" tabindex="1" >
            <v-container fluid v-if="active_tab == 1">
              <v-row>
                <v-col>
                  <v-text-field v-model="ID_Name" label="Nazwa firmy"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field v-model="ID_Street" label="Ulica"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-text-field v-model="ID_PostCode" :rules="[rules.postcode]" label="Kod pocztowy"></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="ID_City" label="Miasto"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-text-field label="Adres email" v-validate="'email'" data-vv-as="Email" name="ID_Email" id="ID_Email" :error-messages="errors.collect('ID_Email')"  v-model="ID_Email"></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>
          <v-tab-item :key="2" tabindex="2" >
            <v-container fluid v-if="active_tab == 2">
              <v-row>
                <v-col>
                  <v-text-field v-model="inspektor_danych_nazwa" label="Nazwa/Imię i Nazwisko"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field v-model="inspektor_danych_ulica" label="Ulica"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-text-field v-model="inspektor_danych_kod_pocztowy" :rules="[rules.postcode]" label="Kod pocztowy"></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="inspektor_danych_miasto" label="Miasto"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-text-field label="Adres email" v-validate="'email'" data-vv-as="Email" name="inspektor_danych_email" id="inspektor_danych_email" :error-messages="errors.collect('inspektor_danych_email')"  v-model="inspektor_danych_email"></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="inspektor_danych_telefon" label="Numer telefonu"></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>
          <v-tab-item :key="3" tabindex="3">
            <v-expansion-panels v-if="active_tab == 3">
              <v-expansion-panel key="1">
                <v-expansion-panel-header>Szablon potwierdzający wizytę</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-container grid-list-xl>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-textarea
                          label="Treść"
                          hint="Specjalne wstawki: %dw% - data wizyty, %gw% - godzina wizyty, %tw% - imie i nazwisko terapeuty"
                          v-model="VisitSmsTemplate"
                        ></v-textarea>
                      </v-flex>
                      <v-flex xs3>
                        <v-text-field
                          v-model.number="DaysBeforeSendVisitSMS"
                          v-validate="'integer'"
                          name="dbfsms"
                          type="number"
                          step="1"
                          min="0"
                          id="dbfsms"
                          :error-messages="errors.collect('dbfsms')"
                          data-vv-as="Ilośc dni"
                          label="Ilość dni przed wizyta do wysłania SMS"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-textarea
                          label="Poprawne odpowiedzi potwierdzające wizyte"
                          hint="Wprowadź listę słów po przecinku. Wielkośc liter nie ma znaczenia."
                          v-model="ConfirmAnswersVisitSMS"
                        ></v-textarea>
                      </v-flex>
                      <v-flex xs12>
                        <v-textarea
                          label="Poprawne odpowiedzi odwołujące wizyte"
                          hint="Wprowadź listę słów po przecinku. Wielkośc liter nie ma znaczenia."
                          v-model="CancelAnswersVisitSMS"
                        ></v-textarea>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel key="2">
                <v-expansion-panel-header>Szablon zaproszenia na wizytę</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-container flud>
                    <v-col cols="12">
                      <v-textarea
                          label="Treść"
                          hint="Specjalne wstawki: %dw% - data wizyty, %gw% - godzina wizyty, %tw% - imie i nazwisko terapeuty"
                          v-model="wizyta_sms_zaproszenie"
                      ></v-textarea>
                    </v-col>
                  </v-container>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel key="3">
                <v-expansion-panel-header>Szablon potwierdzajacy wizyty (kilku pracowników)</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-container flud>
                    <v-col cols="12">
                      <v-textarea
                          label="Treść"
                          hint="Specjalne wstawki: %dw% - data wizyty,%godziny_terapeuci% - lista terapeutów i godzin wizt"
                          v-model="multiVisitSMSTemplate"
                      ></v-textarea>
                    </v-col>
                  </v-container>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel key="4">
                <v-expansion-panel-header>Szablon sms - odwołanie wizyty</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-container flud>
                    <v-col cols="12">
                      <v-textarea
                          label="Treść"
                          hint="Specjalne wstawki: %dw% - data wizyty, %gw% - godzina wizyty, %tw% - imie i nazwisko terapeuty, %opoznienie% - opóźnienie wizyty w minutach (godzina wizyty bedzie opozniona o ta ilosc)"
                          v-model="szablon_sms_odwolanie"
                      ></v-textarea>
                    </v-col>
                  </v-container>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel key="5">
                <v-expansion-panel-header>Szablon sms - opóźnienie wizyty</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-container flud>
                    <v-col cols="12">
                      <v-textarea
                          label="Treść"
                          hint="Specjalne wstawki: %dw% - data wizyty, %gw% - godzina wizyty, %tw% - imie i nazwisko terapeuty, %powod_odwolania% - powód odwołania wizyty"
                          v-model="szablon_sms_opoznienie"
                      ></v-textarea>
                    </v-col>
                  </v-container>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel key="6">
                <v-expansion-panel-header>Szablon sms - bramka sms zaproszenie</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-container flud>
                    <v-col cols="12">
                      <v-textarea
                          label="Treść"
                          hint="Specjalne wstawki: %dw% - data wizyty, %gw% - godzina wizyty, %tw% - imie i nazwisko terapeuty"
                          v-model="szablon_sms_zaproszenie"
                      ></v-textarea>
                    </v-col>
                  </v-container>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel key="7">
                <v-expansion-panel-header>Szablon sms - opinia</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-container flud>
                    <v-col cols="12">
                      <v-textarea
                          label="Treść"
                          hint="Specjalne wstawki: %dw% - data wizyty, %gw% - godzina wizyty, %tw% - imie i nazwisko terapeuty"
                          v-model="szablon_sms_opinia"
                      ></v-textarea>
                    </v-col>
                  </v-container>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel key="8">
                <v-expansion-panel-header>Szablon sms - recepta</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-container flud>
                    <v-col cols="12">
                      <v-textarea
                          label="Treść"
                          hint="Specjalne wstawki: %data% - data wystawienia recepty, %kod_recepty% - kod recepty"
                          v-model="szablon_sms_recepta"
                      ></v-textarea>
                    </v-col>
                  </v-container>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel key="9" v-if="isPayuEnabled">
                <v-expansion-panel-header>Szablon sms - Wizyta (zaproszenie) - link payu</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-container flud>
                    <v-col cols="12">
                      <v-textarea
                          label="Treść"
                          hint="Specjalne wstawki: %dw% - data wizyty, %gw% - godzina wizyty, %tw% - imie i nazwisko terapeuty, %link% - link do płatności"
                          v-model="szablon_sms_wizyta_payu"
                      ></v-textarea>
                    </v-col>
                  </v-container>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel key="10" v-if="isPayuEnabled">
                <v-expansion-panel-header>Szablon sms - Wizyta - link payu przypomnienie</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-container flud>
                    <v-col cols="12">
                      <v-textarea
                          label="Treść"
                          hint="Specjalne wstawki: %dw% - data wizyty, %gw% - godzina wizyty, %tw% - imie i nazwisko terapeuty, %link% - link do płatności"
                          v-model="szablon_sms_wizyta_payu_przypomnienie"
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                          v-model.number="DaysBeforeVisitForPayUReminder"
                          v-validate="'integer'"
                          name="dbpayu"
                          type="number"
                          step="1"
                          min="0"
                          id="dbpayu"
                          :error-messages="errors.collect('dbpayu')"
                          data-vv-as="Ilośc dni (PAYU)"
                          label="Ilość dni przed wizyta do wysłania przypomnienia PAYU (0 - nie wysyłaj)"
                      ></v-text-field>
                    </v-col>
                  </v-container>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-tab-item>
          <v-tab-item :key="4" tabindex="4" v-if="id>0">
            <JednostkiOrganizacyjne :settings_id="id"></JednostkiOrganizacyjne>
          </v-tab-item>
          <v-tab-item :key="5" tabindex="5" v-if="id>0">
            <AgreeTempolates></AgreeTempolates>
          </v-tab-item>
          <v-tab-item :key="6"  v-if="id>0 && $can('do','POKO_SystemAdmin')" tabindex="6">
            <AdditionalOutposts :settingsid="id"></AdditionalOutposts>
          </v-tab-item>
          <v-tab-item :key="7"  v-if="id>0 && $can('do','POKO_SystemAdmin')" tabindex="7">
            <v-container grid-list-xl>
              <v-row row wrap>
                <v-col cols="6">
                <v-text-field
                    v-model.number="calendar_event_height"
                    v-validate="'integer'"
                    name="dbfsms"
                    type="number"
                    step="1"
                    min="0"
                    id="event_height"
                    :error-messages="errors.collect('event_height')"
                    data-vv-as="Wysokość kratki"
                    label="Wysokość kratki kalendarza"
                ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-select v-model="calendarTimeScale" :items="calendarTimeScaleItems" label="Skala czasu kalendarza"></v-select>
                </v-col>
                <v-col cols="6">
                  <v-checkbox label="Wymuś wybór terapeuty na kalendarzu" v-model="force_calendar_to_one_therapist"></v-checkbox>
                </v-col>
                <v-col cols="6"><v-checkbox label="Pokazuj uwagi na kalendarzu" v-model="show_notes_on_calendar_event"></v-checkbox></v-col>
              </v-row>
            </v-container>
          </v-tab-item>
          <v-tab-item :key="8" v-if="id>0 && isPayuEnabled" tabindex="8" >
            <v-container grid-list-xl>
              <v-row row wrap>
                <v-col cols="6">
                  <v-text-field v-model="PayUClientId" label="Client ID"></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="PayUClientSecret" type="password" label="Client Secret"></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="PayUMD5Key" label="Klucz MD5"></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="PayUPosId" label="POS ID"></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model.number="PayUPaymentLinkLifetime" label="Czas życia linku do płatności (w dniach)"></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-checkbox label="Potwierdzaj wizyty poprzez płatność" v-model="PayUConfirmVisitsByPayment"></v-checkbox>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model.number="HoursBeforeVisitForPayURefund" label="Po ilu godzinach przed wizytą blokować zwrot (w godzinach, 0 nie blokuejmy)"></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>
          <v-tab-item :key="9" tabindex="9"  v-if="id>0">
            <TherapistsGroups></TherapistsGroups>
          </v-tab-item>
          <v-tab-item :key="10" v-if="id>0 && $can('do','POKO_SystemAdmin')" tabindex="10">
            <v-container grid-list-xl>
              <v-row>
                <v-col cols="12">
                  <v-card>
                    <v-card-title>Integracja z portalem pacjenta</v-card-title>
                    <v-card-text>
                      <v-row>
                        <v-col cols="12">
                          <v-checkbox
                            v-model="portalSyncEnabled"
                            label="Włącz synchronizację z portalem pacjenta"
                            hint="Po włączeniu dane o terapeutach, usługach i wizytach będą automatycznie synchronizowane z portalem pacjenta"
                            persistent-hint
                          ></v-checkbox>
                        </v-col>
                      </v-row>
                      <v-row v-if="lastPortalSyncAt">
                        <v-col cols="6">
                          <v-text-field
                            :value="formatDateTime(lastPortalSyncAt)"
                            label="Ostatnia synchronizacja"
                            readonly
                            disabled
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field
                            :value="lastPortalSyncStatus"
                            label="Status ostatniej synchronizacji"
                            readonly
                            disabled
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>
          <v-tab-item :key="11" v-if="id>0 && isP1Enabled" tabindex="11">
            <P1Certificates></P1Certificates>
          </v-tab-item>
        </v-tabs>
      </v-card-text>
      <v-card-actions>
        <v-btn color="success" @click="handleSubmit()">Zapisz</v-btn>        
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import {mapActions, mapState} from "vuex";
import { settingsService } from "@/services/";
import {znanyLekarzService} from "../../../services/znanylekarz.service";
import JednostkiOrganizacyjne from "@/components/admin/settings/JednostkiOrganizacyjne";
import AgreeTempolates from "@/components/admin/settings/AgreeTempolates";
import TimePicker from "@/components/shared/TimePicker.vue";
import dayjs from "dayjs";
import AdditionalOutposts from "@/components/admin/settings/AdditionalOutposts.vue";
import TherapistsGroups from "./TherapistsGroups.vue";
import P1Certificates from "@/components/admin/settings/P1Certificates.vue";
export default {
  name: "CompanySettings",
  components: {AdditionalOutposts, AgreeTempolates, JednostkiOrganizacyjne, TimePicker, TherapistsGroups, P1Certificates},
  data: () => ({
      id: 0,
      loading: false,
      CompanyName: '',
      NIP: '',
      regon: '',
      City: '',
      active_tab: 0,
      AddressLine1: '',
      AddressLine2: '',
      Postcode: '',
      ContactNumber: '',
      DaysBeforeSendVisitSMS: 1,
      VisitSmsTemplate: '',
      ConfirmAnswersVisitSMS: '',
      CancelAnswersVisitSMS: '',
      ContactEmail: '',
      znanyLekarzEnabled: false,
      znanyLekarzPlacowkaId: 0,
      znanyLekarzFacilities: [],
      numer_ksiegi_rejestrowej: null,
      www_url: null,
      ID_City: null,
      ID_Email: null,
      ID_Name: null,
        ID_PostCode: null,
      ID_Street: null,
      logo_url: null,
      image_error: false,
      godzina_otwarcia_start: null,
      godzina_otwarcia_koniec: null,
      image_errors: '',
      inspektor_danych_email: null,
      inspektor_danych_kod_pocztowy: null,
      inspektor_danych_miasto: null,
      inspektor_danych_nazwa: null,
      inspektor_danych_telefon: null,
      inspektor_danych_ulica: null,
      typ_dzialanosci: null,
      wizyta_sms_zaproszenie: null,
      numer_budynku: '',
      numer_lokalu: '',      
      typy_dzialanosci: [
        {
            value: 0,
            text: 'Placówka medyczna'
        },
        {
            value: 1,
            text: 'Praktyka fizjoterapeutyczna'
        },
        {
            value: 2,
            text: 'Praktyka lekarska'
        },
        {
          value: 3,
          text: "Salon",          
        },
        {
          value: 4,
          text: "Centrum recepcji",
        }
      ],
      rules: {
        postcode: v => {
          const pattern = /^(\s*|[0-9]{2}-[0-9]{3})$/
          return (v && pattern.test(v)) || "Błędny kod pocztowy."
        }
      },
      multiVisitSMSTemplate: null,
      szablon_sms_odwolanie: null,
      szablon_sms_opoznienie: null,
      szablon_sms_zaproszenie: null,
      szablon_sms_opinia: null,
      szablon_sms_recepta: null,
      calendar_event_height: 0,
      force_calendar_to_one_therapist: false,
      show_notes_on_calendar_event: false,
      szablon_sms_wizyta_payu: null,
      szablon_sms_wizyta_payu_przypomnienie: null,
      PayUClientId: null,
      PayUClientSecret: null,
      PayUPosId: null,
      PayUConfirmVisitsByPayment: false,
      PayUPaymentLinkLifetime: 0,
      DaysBeforeVisitForPayUReminder: 0,
      PayUMD5Key:null,
      HoursBeforeVisitForPayURefund: 0,
      leaveCancelledVisitInCalendar: false,
      smsConfirmationWilLBeSent: false,
      showPaymentIconInCalendar: false,
      showNotesIconInCalendar: false,
      showAdditionalTherapistsForVisitCreation: false,
      allowRegularVisitCreation: false,
      sendAutomaticInvintations: false,
      calendarTimeScale: 30,
      calendarTimeScaleItems: [
        {
          text: '15 minut',
          value: 15
        },
        {
          text: '30 minut',
          value: 30
        },
        {
          text: '60 minut',
          value: 60
        }
      ],
      // Portal Sync settings
      portalSyncEnabled: false,
      lastPortalSyncAt: null,
      lastPortalSyncStatus: null
  }),
  computed: {
    ...mapState('featuresModule',['features']),
    isPayuEnabled: function() {
      return this.features && this.features.PayU
    },
    isP1Enabled: function() {
      return this.features && this.features.IntegracjaP1
    }
  },
  methods: {
    ...mapActions("title", ["updateTitle"]),
    ...mapActions("alert", ["error", "success"]),

    handleSubmit()
    {
      if(this.image_error)
        return
      this.$validator.validate().then(valid => {
        if (valid) {
          settingsService.UpdateCompanySettings({
            companyName: this.CompanyName,
            city: this.City,
            addressLine1: this.AddressLine1,
            addressLine2: this.AddressLine2,
            nip: this.NIP,
            postcode: this.Postcode,
            contactNumber: this.ContactNumber,
            daysBeforeSendVisitSMS: this.DaysBeforeSendVisitSMS,
            visitSMSTemplate: this.VisitSmsTemplate,
            confirmAnswersVisitSMS: this.ConfirmAnswersVisitSMS,
            cancelAnswersVisitSMS: this.CancelAnswersVisitSMS,
            contactEmail: this.ContactEmail,
            znanyLekarzPlacowkaId: Number(this.znanyLekarzPlacowkaId),
            iD_Name: this.ID_Name,
            iD_Street: this.ID_Street,
            iD_PostCode: this.ID_PostCode,
            iD_Email: this.ID_Email,
            iD_City: this.ID_City,
            wwW_Url: this.www_url,
            regon: this.regon,
            numer_ksiegi_rejestrowej: this.numer_ksiegi_rejestrowej,
            logo_base64: this.logo_url,
            godzina_otwarcia_start: this.godzina_otwarcia_start ? dayjs().format('YYYY-MM-DD') +' '+this.godzina_otwarcia_start : null,
            godzina_otwarcia_koniec: this.godzina_otwarcia_koniec ? dayjs().format('YYYY-MM-DD') +' '+this.godzina_otwarcia_koniec : null,
            inspektor_danych_email: this.inspektor_danych_email,
            inspektor_danych_kod_pocztowy: this.inspektor_danych_kod_pocztowy,
            inspektor_danych_miasto: this.inspektor_danych_miasto,
            inspektor_danych_nazwa: this.inspektor_danych_nazwa,
            inspektor_danych_telefon: this.inspektor_danych_telefon,
            inspektor_danych_ulica: this.inspektor_danych_ulica,
            typ_dzialanosci: this.typ_dzialanosci,
            wizyta_sms_zaproszenie: this.wizyta_sms_zaproszenie,
            multiVisitSMSTemplate: this.multiVisitSMSTemplate,
            szablon_sms_odwolanie: this.szablon_sms_odwolanie,
            szablon_sms_opoznienie: this.szablon_sms_opoznienie,
            szablon_sms_zaproszenie: this.szablon_sms_zaproszenie,
            szablon_sms_recepta: this.szablon_sms_recepta,
            szablon_sms_opinia: this.szablon_sms_opinia,
            CalendarEventHeight: this.calendar_event_height,
            ForceCalendarToOneTherapist:  this.force_calendar_to_one_therapist,
            ShowNotesOnCalendarEvent: this.show_notes_on_calendar_event,
            numer_budynku: this.numer_budynku,
            numer_lokalu: this.numer_lokalu,
            payUClientId: this.PayUClientId,
            payUClientSecret: this.PayUClientSecret,
            payUPosId: this.PayUPosId,
            payUConfirmVisitsByPayment: this.PayUConfirmVisitsByPayment,
            payUPaymentLinkLifetime: this.PayUPaymentLinkLifetime,
            szablon_sms_wizyta_payu: this.szablon_sms_wizyta_payu,
            szablon_sms_wizyta_payu_przypomnienie: this.szablon_sms_wizyta_payu_przypomnienie,
            daysBeforeVisitForPayUReminder: this.DaysBeforeVisitForPayUReminder,
            payUMD5Key: this.PayUMD5Key,
            hoursBeforeVisitForPayURefund: this.HoursBeforeVisitForPayURefund,
            leaveCancelledVisitInCalendar: this.leaveCancelledVisitInCalendar,
            smsConfirmationWilLBeSent: this.smsConfirmationWilLBeSent,
            showPaymentIconInCalendar: this.showPaymentIconInCalendar,
            showNotesIconInCalendar: this.showNotesIconInCalendar,
            showAdditionalTherapistsForVisitCreation: this.showAdditionalTherapistsForVisitCreation,
            allowRegularVisits: this.allowRegularVisitCreation,
            sendAutomaticInvintations: this.sendAutomaticInvintations,
            calendarTimeScale: this.calendarTimeScale,
            portalSyncEnabled: this.portalSyncEnabled
          }).then(()=> {
            this.success("Zapisano")
          }).catch(e=> {
            console.log(e)
            this.error("Błąd zapisu ustawień")
          })
        }
      });      
    },
    onFileChange(e) {
      if(e) {
        const file = e
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = e => {
          let img = new Image();
          img.onload = () => {
            const fileSize = Math.round((file.size / 1024));

            if(fileSize > 1024)
            {
              this.image_error = true
              this.image_errors = 'Przekroczono maksymalny rozmiar pliku 1MB'
              return
            }
            if (img.width > 400 || img.height > 400) {
              this.image_error = true
              this.image_errors = 'Maksymalny rozmiar loga to: 400 pikseli x 400 pikseli'
              return
            }

            this.logo_url = img.src
          }
          img.src = e.target.result
        }//this.logo_url = e.target.result
      }
      else
      {
        this.image_error = false
        this.image_errors = ''
      }
    },
    formatDateTime(val) {
      if (!val) return ''
      return dayjs(val).format("DD-MM-YYYY HH:mm")
    },
    getSettingsData()
    {
      settingsService.GetCompanySettings().then(success=> {
        
        if(success.data.result)
        {

          let placowka = 0
          var data = success.data.result
          if(data.id > 0)
          {
            this.id = data.id
            this.CompanyName = data.companyName
            this.City = data.city
            this.AddressLine1 = data.addressLine1
            this.AddressLine2 = data.addressLine2
            this.NIP = data.nip
            this.Postcode = data.postcode
            this.ContactNumber = data.contactNumber
            this.DaysBeforeSendVisitSMS = data.daysBeforeSendVisitSMS
            this.VisitSmsTemplate = data.visitSMSTemplate
            this.ConfirmAnswersVisitSMS = data.confirmAnswersVisitSMS
            this.CancelAnswersVisitSMS = data.cancelAnswersVisitSMS
            this.ContactEmail = data.contactEmail
            this.znanyLekarzEnabled = data.znanyLekarzEnabled
            this.www_url = data.wwW_Url
            this.ID_City = data.iD_City
            this.ID_Email = data.iD_Email
            this.ID_Name = data.iD_Name
            this.ID_PostCode = data.iD_PostCode
            this.ID_Street = data.iD_Street
            this.numer_ksiegi_rejestrowej = data.numer_ksiegi_rejestrowej
            this.logo_url = data.logo_base64
            this.inspektor_danych_email = data.inspektor_danych_email
            this.inspektor_danych_kod_pocztowy = data.inspektor_danych_kod_pocztowy
            this.inspektor_danych_miasto = data.inspektor_danych_miasto
            this.inspektor_danych_nazwa = data.inspektor_danych_nazwa
            this.inspektor_danych_telefon = data.inspektor_danych_telefon
            this.inspektor_danych_ulica = data.inspektor_danych_ulica
            this.typ_dzialanosci = data.typ_dzialanosci
            this.wizyta_sms_zaproszenie = data.wizyta_sms_zaproszenie
            this.multiVisitSMSTemplate = data.multiVisitSMSTemplate
            this.szablon_sms_zaproszenie = data.szablon_sms_zaproszenie
            this.szablon_sms_opoznienie = data.szablon_sms_opoznienie
            this.szablon_sms_odwolanie = data.szablon_sms_odwolanie
            this.szablon_sms_opinia = data.szablon_sms_opinia
            this.show_notes_on_calendar_event = data.showNotesOnCalendarEvent
            this.force_calendar_to_one_therapist = data.forceCalendarToOneTherapist
            this.calendar_event_height = data.calendarEventHeight
            this.regon = data.regon
            this.numer_lokalu = data.numer_lokalu
            this.numer_budynku = data.numer_budynku
            this.szablon_sms_recepta = data.szablon_sms_recepta
            this.szablon_sms_wizyta_payu = data.szablon_sms_wizyta_payu
            this.szablon_sms_wizyta_payu_przypomnienie = data.szablon_sms_wizyta_payu_przypomnienie
            this.PayUClientId = data.payUClientId
            this.PayUClientSecret = data.payUClientSecret
            this.PayUPosId = data.payUPosId
            this.PayUConfirmVisitsByPayment = data.payUConfirmVisitsByPayment
            this.PayUPaymentLinkLifetime = data.payUPaymentLinkLifetime
            this.DaysBeforeVisitForPayUReminder = data.daysBeforeVisitForPayUReminder
            this.PayUMD5Key = data.payUMD5Key
            this.HoursBeforeVisitForPayURefund = data.hoursBeforeVisitForPayURefund
            this.leaveCancelledVisitInCalendar = data.leaveCancelledVisitInCalendar
            this.smsConfirmationWilLBeSent = data.smsConfirmationWilLBeSent
            this.showPaymentIconInCalendar = data.showPaymentIconInCalendar
            this.showNotesIconInCalendar = data.showNotesIconInCalendar
            this.showAdditionalTherapistsForVisitCreation = data.showAdditionalTherapistsForVisitCreation
            this.allowRegularVisitCreation = data.allowRegularVisits
            this.sendAutomaticInvintations = data.sendAutomaticInvintations
            this.calendarTimeScale = data.calendarTimeScale == 0 ? 30 : data.calendarTimeScale
            // Portal Sync settings
            this.portalSyncEnabled = data.portalSyncEnabled
            this.lastPortalSyncAt = data.lastPortalSyncAt
            this.lastPortalSyncStatus = data.lastPortalSyncStatus
            if(data.godzina_otwarcia_start)
            {
              this.godzina_otwarcia_start = dayjs(data.godzina_otwarcia_start).format("HH:mm")
            }
            if(data.godzina_otwarcia_koniec)
            {
              this.godzina_otwarcia_koniec = dayjs(data.godzina_otwarcia_koniec).format("HH:mm")
            }
            placowka = data.znanyLekarzPlacowkaId
          }
          if(this.znanyLekarzEnabled)
          {
            znanyLekarzService.GetFacilities().then(result=> {
              if(result.data && result.data.result)
              {
                this.znanyLekarzFacilities = result.data.result
                this.znanyLekarzPlacowkaId = placowka.toString()
              }
            }).catch(err => {
              console.log(err)
            })
          }
        }
        else
        {
          throw 'error'
        }
      }).catch(error => {
        console.log(error)
        this.error("Błąd pobierania ustawień firmy.")
      })      
    }
  },
  created() {
    this.updateTitle("Ustawienia firmy");
    this.getSettingsData();
  },

};
</script>

<style>
</style>
